import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MedSummaryEntry } from './schemas'

export type MedSummaryEntriesState = {
  // Keyed by parent id: a legacy job id or a living-asset id (both UUIDs, never colliding)
  entries: { [parentId: string]: MedSummaryEntry[] }
}

const initialState: MedSummaryEntriesState = {
  entries: {},
}

export const medSummaryEntriesSlice = createSlice({
  name: 'medSummaryEntriesState',
  initialState,
  reducers: {
    nullifyData: () => initialState,

    setEntriesList: (state, action: PayloadAction<{ parentId: string; entries: MedSummaryEntry[] }>) => {
      state.entries[action.payload.parentId] = action.payload.entries
    },

    updateEntry: (state, action: PayloadAction<{ parentId: string; entry: MedSummaryEntry }>) => {
      const { parentId, entry } = action.payload
      const entries = state.entries[parentId]
      if (!entries) return

      const index = entries.findIndex((e) => e.id === entry.id)
      if (index !== -1) {
        entries[index] = entry
      }
    },
  },
})

// Actions
export const MedSummaryEntriesActions = medSummaryEntriesSlice.actions

export default medSummaryEntriesSlice.reducer
